var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.items && _vm.items.length)?_c('nav',[_c('TreeMenu',{attrs:{"items":_vm.items,"max-depth":_vm.maxDepth,"delay":400,"active-ids":_vm.activeMenuItemIDs,"toggle-event":_vm.toggleEvent}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }